import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomModal,
  InputText,
} from '../../../../../components'
import { errorHandler } from '../../../../../services/util/error.service'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import { OPERACOES_TYPE } from '../CadastroOperacaoEstoqueHook'

const INITIAL_STATE = {
  name: '',
  selectedType: null,
  entrada_aplicativo: false,
  selectedOperacaoEntrada: null,
  selectedOperacaoSaida: null,
  loading: false,
  errorMessage: null,
}

const ModalCadastroOperacaoEstoque = ({
  visible,
  onModalSave,
  onError,
  onModalClose,
  tpId,
  selectedOperacao,
  operacoesEntradaSaida,
}) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (
      state.grupo_de_operacao &&
      (state.grupo_de_operacao === 'Avulso' || state.grupo_de_operacao === 'Inventario')
    )
      setState(prevState => ({ ...prevState, entrada_aplicativo: false }))
  }, [state.grupo_de_operacao])

  useEffect(() => {
    if (visible) {
      if (selectedOperacao) {
        if (
          selectedOperacao.type === OPERACOES_TYPE.ENTRADA ||
          selectedOperacao.type === OPERACOES_TYPE.SAIDA
        ) {
          const { id, name, type, entrada_aplicativo, grupo_de_operacao } = selectedOperacao
          setState(prevState => ({
            ...prevState,
            id,
            name,
            selectedType: type,
            entrada_aplicativo: !!entrada_aplicativo,
            selectedOperacaoSaida: null,
            selectedOperacaoEntrada: null,
            grupo_de_operacao: grupo_de_operacao,
          }))
        } else {
          // Transferência
          const { id, name, operacao_entrada_id, operacao_saida_id, grupo_de_operacao } =
            selectedOperacao
          setState(prevState => ({
            ...prevState,
            id,
            name,
            selectedType: OPERACOES_TYPE.TRANSFERENCIA,
            selectedOperacaoSaida: operacao_saida_id,
            selectedOperacaoEntrada: operacao_entrada_id,
            entrada_aplicativo: false,
            grupo_de_operacao,
          }))
        }
      } else {
        setState({ ...INITIAL_STATE })
      }
    }
  }, [visible])

  useEffect(() => {
    if (state.loading) {
      httpHandler(tpId, state, (error, operacao) => {
        setState(prevState => {
          error ? onError(error) : onModalSave(prevState.selectedType, operacao)
          return { ...prevState, loading: false }
        })
      })
    }
  }, [state.loading])

  // Helper
  const getDropdownOptions = type => {
    const operacoes = operacoesEntradaSaida.filter(o => o.type === type)
    return operacoes.map(o => ({ value: o.id, label: o.name }))
  }

  // Events
  const onBtnSalvarClicked = () => {
    const {
      name,
      selectedType,
      selectedOperacaoEntrada,
      selectedOperacaoSaida,
      grupo_de_operacao,
    } = state
    if (name.trim().length === 0) {
      onError('O nome da operação é obrigatório')
    } else if (!selectedType) {
      onError('O tipo de operação é obrigatório')
    } else if (selectedType === OPERACOES_TYPE.TRANSFERENCIA) {
      if (!selectedOperacaoEntrada) {
        onError('O campo operação de entrada é obrigatório')
      } else if (!selectedOperacaoSaida) {
        onError('O campo operação de saída é obrigatório')
      } else {
        setState({ ...state, loading: true })
      }
    } else if (!grupo_de_operacao) {
      onError('O grupo da operação é obrigatório')
    } else {
      setState({ ...state, loading: true })
    }
  }

  // Render
  return (
    <CustomModal
      header={state.id ? 'Editar Operação' : 'Nova Operação'}
      isVisible={visible}
      onClose={onModalClose}
      width={450}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <span style={{ color: '#14B0BF', fontSize: '0.8rem' }}>(*) Campo Obrigatório</span>
        </div>
        <div className="p-col-12">
          <InputText
            label="Nome da Operação* :"
            marginTop={10}
            value={state.name}
            onChange={name => setState({ ...state, name })}
          />
        </div>
        <div className="p-col-12">
          <CustomDropdown
            label="Tipo de Operação* :"
            marginTop={10}
            disabled={state.id}
            options={[
              { value: OPERACOES_TYPE.ENTRADA, label: OPERACOES_TYPE.ENTRADA },
              { value: OPERACOES_TYPE.SAIDA, label: OPERACOES_TYPE.SAIDA },
              { value: OPERACOES_TYPE.TRANSFERENCIA, label: OPERACOES_TYPE.TRANSFERENCIA },
            ]}
            value={state.selectedType}
            onChange={selectedType => setState({ ...state, selectedType })}
          />
        </div>
        {state.selectedType === 'Entrada' || state.selectedType === 'Saída' ? (
          <>
            {!state.grupo_de_operacao ||
            (state.grupo_de_operacao &&
              state.grupo_de_operacao !== 'Avulso' &&
              state.grupo_de_operacao !== 'Inventario') ? (
              <div className="p-col-12 p-mt-3">
                <CustomCheckbox
                  onChange={entrada_aplicativo => setState({ ...state, entrada_aplicativo })}
                  checked={!!state.entrada_aplicativo}
                  disabled={state.id}
                >
                  Operação Padrão do Aplicativo Móvel
                </CustomCheckbox>
              </div>
            ) : null}

            <div className="p-col-12">
              <CustomDropdown
                label="Grupo da Operação* :"
                marginTop={10}
                disabled={!!state.id && !!(selectedOperacao && selectedOperacao.grupo_de_operacao)}
                options={[
                  { value: 'Recebimento', label: 'Recebimento' },
                  { value: 'Expedição', label: 'Expedição' },
                  { value: 'Inventario', label: 'Inventario' },
                  { value: 'Avulso', label: 'Avulso' },
                  { value: 'Transferência', label: 'Transferência' },
                ]}
                value={state.grupo_de_operacao}
                onChange={grupo_de_operacao => setState({ ...state, grupo_de_operacao })}
              />
            </div>
          </>
        ) : null}
        {state.selectedType === 'Transferência' ? (
          <>
            <div className="p-col-6">
              <CustomDropdown
                label="Operação de Entrada* :"
                marginTop={10}
                options={getDropdownOptions(OPERACOES_TYPE.ENTRADA)}
                value={state.selectedOperacaoEntrada}
                onChange={selectedOperacaoEntrada =>
                  setState({ ...state, selectedOperacaoEntrada })
                }
                disabled={state.id}
              />
            </div>
            <div className="p-col-6">
              <CustomDropdown
                label="Operação de Saida* :"
                marginTop={10}
                disabled={state.id}
                options={getDropdownOptions(OPERACOES_TYPE.SAIDA)}
                value={state.selectedOperacaoSaida}
                onChange={selectedOperacaoSaida => setState({ ...state, selectedOperacaoSaida })}
              />
            </div>
          </>
        ) : (
          ''
        )}
        <div className="p-col-12" style={{ paddingTop: 32, textAlign: 'end' }}>
          <Btn isLoading={state.loading} onClick={onBtnSalvarClicked}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}

export default connect()(ModalCadastroOperacaoEstoque)

// A idéia no futuro é tem um endpoint para cada grupo de operações: Entrada/Saida e Transferencia
function httpHandler(tpId, data, cb) {
  EstoqueHttp.saveOperacaoEstoqueEntradaSaida(tpId, data)
    .then(operacao => cb(null, operacao))
    .catch(err => cb(errorHandler(err), null))
}
